var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventSetup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M14.7,13.1h0.5c0.5,0,0.9-0.4,0.9-0.9V8.5c0-0.5-0.4-0.9-0.9-0.9h-0.5c-0.5,0-0.9,0.4-0.9,0.9v3.7 C13.7,12.7,14.2,13.1,14.7,13.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M27.4,13.1h0.5c0.5,0,0.9-0.4,0.9-0.9V8.5c0-0.5-0.4-0.9-0.9-0.9h-0.5c-0.5,0-0.9,0.4-0.9,0.9v3.7 C26.5,12.7,26.9,13.1,27.4,13.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M18.2,17.4h-2.4c-0.2,0-0.4,0.2-0.4,0.4v1.8c0,0.2,0.2,0.4,0.4,0.4h2.4c0.2,0,0.4-0.2,0.4-0.4v-1.8 C18.7,17.6,18.5,17.4,18.2,17.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M22.5,17.4H20c-0.2,0-0.4,0.2-0.4,0.4v1.8c0,0.2,0.2,0.4,0.4,0.4h2.4c0.2,0,0.4-0.2,0.4-0.4v-1.8 C22.9,17.6,22.7,17.4,22.5,17.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M26.7,17.4h-2.4c-0.2,0-0.4,0.2-0.4,0.4v1.8c0,0.2,0.2,0.4,0.4,0.4h2.4c0.2,0,0.4-0.2,0.4-0.4v-1.8 C27,17.6,26.9,17.4,26.7,17.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M30.9,17.4h-2.4c-0.2,0-0.4,0.2-0.4,0.4v1.8c0,0.2,0.2,0.4,0.4,0.4h2.4c0.2,0,0.4-0.2,0.4-0.4v-1.8 C31.2,17.6,31.1,17.4,30.9,17.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M11.7,23.6H14c0.2,0,0.4-0.2,0.4-0.4v-1.8c0-0.2-0.2-0.4-0.4-0.4h-2.4c-0.2,0-0.4,0.2-0.4,0.4v1.8 C11.2,23.4,11.4,23.6,11.7,23.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#28B557",
    d: "M15.9,23.7h2.4c0.2,0,0.4-0.2,0.4-0.4v-1.8c0-0.2-0.2-0.5-0.4-0.5h-2.4c-0.2,0-0.4,0.3-0.4,0.5v1.8 C15.5,23.5,15.6,23.7,15.9,23.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M19.7,21.4v1.8c0,0.2,0.2,0.4,0.4,0.4h2.4c0.2,0,0.4-0.2,0.4-0.4v-1.8c0-0.2-0.2-0.4-0.4-0.4H20 C19.8,21,19.7,21.2,19.7,21.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M24.2,23.6h2.4c0.2,0,0.4-0.2,0.4-0.4v-1.8c0-0.2-0.2-0.4-0.4-0.4h-2.4c-0.2,0-0.4,0.2-0.4,0.4v1.8 C23.9,23.4,24,23.6,24.2,23.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M30.9,23.6c0.2,0,0.4-0.2,0.4-0.4v-1.8c0-0.2-0.2-0.4-0.4-0.4h-2.4c-0.2,0-0.4,0.2-0.4,0.4v1.8 c0,0.2,0.2,0.4,0.4,0.4H30.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M11.2,25.1v1.8c0,0.2,0.2,0.4,0.4,0.4H14c0.2,0,0.4-0.2,0.4-0.4v-1.8c0-0.2-0.2-0.4-0.4-0.4h-2.4 C11.4,24.7,11.2,24.9,11.2,25.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M18.2,24.7h-2.4c-0.2,0-0.4,0.2-0.4,0.4v1.8c0,0.2,0.2,0.4,0.4,0.4h2.4c0.2,0,0.4-0.2,0.4-0.4v-1.8 C18.7,24.9,18.5,24.7,18.2,24.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M22.5,24.7H20c-0.2,0-0.4,0.2-0.4,0.4v1.8c0,0.2,0.2,0.4,0.4,0.4h2.4c0.2,0,0.4-0.2,0.4-0.4v-1.8 C22.9,24.9,22.7,24.7,22.5,24.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M14,28.4h-2.4c-0.2,0-0.4,0.2-0.4,0.4v1.8c0,0.2,0.2,0.4,0.4,0.4H14c0.2,0,0.4-0.2,0.4-0.4v-1.8 C14.5,28.6,14.3,28.4,14,28.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M18.2,28.4h-2.4c-0.2,0-0.4,0.2-0.4,0.4v1.8c0,0.2,0.2,0.4,0.4,0.4h2.4c0.2,0,0.4-0.2,0.4-0.4v-1.8 C18.7,28.6,18.5,28.4,18.2,28.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M22.5,28.4H20c-0.2,0-0.4,0.2-0.4,0.4v1.8c0,0.2,0.2,0.4,0.4,0.4h2.4c0.2,0,0.4-0.2,0.4-0.4v-1.8 C22.9,28.6,22.7,28.4,22.5,28.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M9,10.1c-0.6,0-1.1,0.5-1.1,1.1v21.9c0,0.6,0.5,1.1,1.1,1.1H24c-0.2-0.6-0.4-1.1-0.5-1.7H9.7V15.9h23.2V24 l1.7,0.8V11.2c0-0.6-0.5-1.1-1.1-1.1h-4.1v2.1c0,0.8-0.7,1.5-1.5,1.6h-0.5c-0.8-0.1-1.5-0.8-1.5-1.6v-2.1h-9.2v2.1 c0,0.9-0.7,1.6-1.6,1.6h-0.4c-0.9,0-1.6-0.7-1.6-1.6v-2.1H9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M37,31c0-3.5-2.9-6.4-6.4-6.4s-6.4,2.9-6.4,6.4c0,3.5,2.9,6.4,6.4,6.4S37,34.5,37,31z M25.5,31 c0-2.8,2.3-5.1,5.1-5.1s5.1,2.3,5.1,5.1s-2.3,5.1-5.1,5.1S25.5,33.8,25.5,31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M30.7,36.1c2.8,0,5.1-2.3,5.1-5.1s-2.3-5.1-5.1-5.1s-5.1,2.3-5.1,5.1S27.8,36.1,30.7,36.1z M30.9,27.4 c0.2,0.3,0.8,1.7,0.8,1.7c0,0.1,0.1,0.2,0.2,0.2l1.9,0.2c0.4,0,0.4,0.3,0.2,0.5l-1.4,1.3c-0.1,0-0.1,0.1-0.1,0.2l0.4,1.9 c0,0.3-0.2,0.5-0.5,0.3l-1.6-1h-0.3l-1.6,1c-0.3,0.2-0.5,0-0.5-0.3l0.4-1.9v-0.2c-0.5-0.4-1-0.8-1.4-1.3c-0.3-0.2-0.2-0.5,0.1-0.5 l1.9-0.2c0.1,0,0.2-0.1,0.2-0.2c0,0,0.6-1.4,0.8-1.7C30.5,27.1,30.7,27.1,30.9,27.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC00",
    d: "M29.5,29.1c0,0.1-0.1,0.2-0.2,0.2l-1.9,0.2c-0.3,0-0.4,0.3-0.1,0.5c0.4,0.5,0.9,0.9,1.4,1.3v0.2l-0.4,1.9 c0,0.3,0.2,0.5,0.5,0.3l1.6-1h0.3l1.6,1c0.3,0.2,0.5,0,0.5-0.3l-0.4-1.9c0-0.1,0-0.2,0.1-0.2L34,30c0.2-0.2,0.2-0.5-0.2-0.5 l-1.9-0.2c-0.1,0-0.2-0.1-0.2-0.2c0,0-0.6-1.4-0.8-1.7c-0.2-0.3-0.4-0.3-0.5,0C30.2,27.7,29.5,29.1,29.5,29.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventSetup);
export default __webpack_public_path__ + "static/media/event_setup.4fc2b73ea309265874ac9349d9d29c3f.svg";
export { ForwardRef as ReactComponent };